import { render } from "./WatchList.vue?vue&type=template&id=5100558f&scoped=true"
import script from "./WatchList.vue?vue&type=script&lang=js"
export * from "./WatchList.vue?vue&type=script&lang=js"

import "./WatchList.vue?vue&type=style&index=0&id=5100558f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5100558f"]])

export default __exports__